module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "List_of_Tables"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('b', [_c('i', [_vm._v("Tables")])])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "img-para"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/15_Chapter01#tab_1"
    }
  }, [_vm._v("1:     Selected Heavy Artillery Ranges")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15_Chapter01#tab_2"
    }
  }, [_vm._v("2:     Heavy Artillery of the Gribeauval System")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15_Chapter01#tab_3"
    }
  }, [_vm._v("3:     Heavy Artillery of the Système An XI")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15_Chapter01#tab_4"
    }
  }, [_vm._v("4:     French Heavy Artillery Ranges")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter02#tab_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:     Estimated Requirements to Defend Fortresses")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter02#tab_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6:     Mortar Ranges")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter02#tab_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7:     Gunpowder Ingredients by Weight")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter02#tab_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8:     Men Required to Serve British Siege Guns")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter02#tab_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9:     The Fortifications of Torres Vedras")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter04#tab_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10:     Congreve Rocket Ranges")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05#tab_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11:     French Naval Artillery, 1758")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05#tab_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12:     Carronade Dimensions")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05#tab_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13:     British Marine Detachments, 1747")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05#tab_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14:     French Gun-Crew Strength")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05#tab_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15:     Long Gun Recoil")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05#tab_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16:     Carronade Ranges")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05#tab_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17:     Ranges of British Iron Naval Long Guns")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05#tab_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18:     Weights of Naval Canister Rounds")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05#tab_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19:     Naval Grape Shot individual Round Weight")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05#tab_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20:     French Naval Gun Carriages")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05#tab_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21:     Ranges of British Iron Naval Mortars, 1798")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#tab_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22:     Foot Artillery Uniforms")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#tab_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23:     French Imperial Guard Artillery Uniforms")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#tab_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24:     Horse Artillery Uniforms")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#tab_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25:     Artillery Train Uniforms")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#tab_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26:     Engineer Uniforms")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#tab_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27:     Naval Uniforms")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#tab_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28:     Marine Corps Uniforms")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08#tab_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29:     French Ammunition Used at their Siege of Ciudad Rodrigo 1810")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08#tab_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30:     Guns Captured after the French Evacuation of Almeida, 1811")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08#tab_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31:     British Siege Train Planned for the 1811 Siege of Ciudad Rodrigo")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08#tab_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32:     Allied Ordnance at Ciudad Rodrigo, Badajoz, and San Sebastian")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08#tab_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33:     British Engineer Establishment in the Peninsula before the Sieges")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08#tab_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34:     Allied Ammunition Expenditure at Ciudad Rodrigo, Badajoz, and San Sebastian")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08#tab_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35:     British Ammunition expenditure, Badajoz, March–April 1812")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08#tab_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36:     Allied Artillery Personnel at Badajoz")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08#tab_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37:     Allied Artillery Losses at the Siege of Badajoz")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08#tab_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38:     Siege Train Ordered from England for Operations in 1813")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08#tab_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39:     Allied Artillery, San Sebastian, 1813")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08#tab_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40:     Allied Ammunition Expenditure, First Siege of San Sebastian")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08#tab_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41:     Allied Artillery at the Start of the Second Siege of San Sebastian")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08#tab_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42:     Allied Ammunition Expenditure, Second Siege of San Sebastian")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter11#tab_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43:     First Six Frigates of the US Navy")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter11#tab_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44:     The Six Subscription Frigates of the US Navy")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter11#tab_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45:     Warship Ratings")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter11#tab_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46:     Ships of the US Navy in June 1812")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter11#tab_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47:     Royal Navy Ships on the North American Station, 18124")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter11#tab_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48:     Royal Navy Strength in 1812 – Major Vessels")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter11#tab_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49:     Comparison of the USS "), _c('i', [_vm._v("Constitution")]), _vm._v(" and Her Opponents")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter11#tab_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50:     Ship-to-Ship Engagements in the War of 1812")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter11#tab_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51:     Carronade Calibres and Ranges")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter11#tab_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52:     British Naval Ordnance Windage")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter12#tab_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53:     The American Fleet on Lake Erie")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter12#tab_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54:     The British Fleet on Lake Erie")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter12#tab_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55:     The Rival Fleets on Lake Ontario, late 1814")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter12#tab_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56:     The Rival Fleets on Lake Champlain")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b09aced2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_List_of_Tables.vue
// module id = 69
// module chunks = 0